(function() {
    var $iq_config = function() {
        var config = {
            version: "",
            client_path: "",
            server_path: ""
        }
        var getConfig = function(_config) {
            if (_config) {
                angular.extend(config, _config);
            }
            return config;
        }
        this.$get = [function() {
            return {
                config: getConfig,
                client_path: function() {
                    return config.client_path;
                },
                server_path: function() {
                    return config.server_path;
                }
            }
        }]
        this.config = getConfig;
    }
    var $iq_queue = function(){
    	var queue = {};
    	this.$get = ["$rootScope", "$q", function($rootScope, $q) {
    		return {
    			get:function(str){
    				if(!queue[str]){
        				var def = $q.defer();
        				queue[str] = def;
    				}
    				return queue[str];
    			}
    		}
    	}]
    }
    var $iq_loading = function() {
        var loadingShow = false;

        this.$get = ["$rootScope", "$timeout", function($rootScope, $timeout) {
            var funcs = {
                show: function() {
                    loadingShow = true;
                    $rootScope.loadingShow = loadingShow;
                },
                hide: function() {
                    $timeout(function() {

                        loadingShow = false;
                        $rootScope.loadingShow = loadingShow;
                    }, 500)
                }
            };
            return funcs;
        }];
    }

    var $iq_httpError = function(){

    	var loginUrl = "/login/";
    	if(document.domain=="iquicker.digitalchina.com"){
    		loginUrl = "http://dcone.digitalchina.com";
    	}
    	if(document.domain=="iquicker.dcits.com"){
    		loginUrl = "http://home.dcits.com";
    	}
    	var remHistory = true;
        var statuscode = {
            NOLOGIN: 401, //登录失败
            FORBIDDEN: 403, //没有权限
            TIMEOUT: 408, //登录超时
            NOTFOUND_DATA_MAIN:4041,//未找到主数据 页面跳转
            NOTFOUND_DATA_SUB:4042,//未找到指定数据 提示
            FAILURE: 500,
            NOTFOUND: 404
        } //未找到路径


        this.loginUrl = function(url){
        	if(url){
        		loginUrl = url;
        	}
        	return loginUrl;
        }
        this.remHistory = function(tmp){
        	if(tmp){
        		remHistory = tmp;
        	}
        	return remHistory;
        }
    	this.$get = ["$iq_config", "$injector", "$q", "$location", "localStorageService", "$iq_loading","$templateCache", function($iq_config, $injector, $q, $location, localStorageService, $iq_loading,$templateCache) {
	        var _loginServerPath = $iq_config.config().server_path + "login";

	        var intercept = false;

	        var loginedOnce = false; //是否已登录
	        var opend = false;
	        var alertOpend = false;
	        var errorAlert = function() {
	        	console.log("system error!!!");
	        	return ;
//	            if (alertOpend == false) {
//	                alertOpend = true;
//
//                	$iq_window = $injector.get("$iq_window")
//                	$iq_window.alert({
//                        message: "系统错误，请刷新重试或联系管理员！",
//                        type : 'warn'
//                    })
//	            }
	        }
	        var askLogin = function() {

	            if (localStorageService.isSupported) {
	            	if(remHistory){
		                localStorageService.set("historyUrl", location.href);
	            	}else{
		                localStorageService.set("historyUrl", "");
	            	}
	            }
	            intercept = true;
	            alertOpend = true;
	            location.href = loginUrl; //跳转到登录页面
	        }
	        var ask403 = function() {
	            if (opend == false) {
	                opend = true;
	                $iqmodal = $injector.get("$iqmodal");
	                var modalInstance = $iqmodal.open({
	                    backdrop: false,
	                    windowClass: 'modal mymodal confirm-modal',
	                    template: '<div class="modal-content"><div class="modal-body"><div class="confirm-tips">没有权限进行此操作！</div><div class="btn-groups"><input type="button" value="返回上一页" ng-click="back()" class="btn btn-save"><input type="button" value="返回登录页" ng-click="toLogin()" class="btn btn-cancel"></div></div></div>',
	                    controller: function($scope, $modalInstance, $timeout, $iq_http) {
	                        $scope.toLogin = function() {
	                            location.href = loginUrl; //跳转到登录页面
	                            opend = false;
	                            $modalInstance.close('ok');
	                        }
	                        $scope.back = function() {
	                            //$location.replace();
	                            history.back();
	                            opend = false;
	                            $modalInstance.close('ok');
	                            //location.href = _loginUrl; //跳转到登录页面
	                        }
	                    }
	                });
	                intercept = true;
	                return modalInstance;
	            }
	        }
	        var redirectToDataNotFoundPage = function(){
	        	$location.replace();
	            $location.path("/4041");
	        }
	        return {
	            logined: function() {
	                loginedOnce = true;
	            },
	            intercept: function() {
	                return intercept;
	            },
	            loginUrl : function(url){
	            	if(url){
	            		loginUrl = url;
	            	}
	            	return loginUrl;
	            },
	            dealError: function(error) {
	                //console.log(error.status);
	                $iq_loading.hide();
	                if (!error) {
	                    errorAlert();
	                } else if (!error.data) {
	                    errorAlert("系统错误!");
	                } else if (error.status == statuscode.NOLOGIN || error.data.status == statuscode.NOLOGIN) {
	                    //http请求header为401 或 后台返回401
	                    askLogin();
	                } else if (error.status == statuscode.FORBIDDEN || error.data.status == statuscode.FORBIDDEN) {
	                    //http请求header为403 或 后台返回403
	                    ask403();
	                } else if (error.status == statuscode.TIMEOUT || error.data.status == statuscode.TIMEOUT) {
	                    //http请求header为408 或 后台返回408
	                    askLogin();
	                } else if (error.status == statuscode.FAILURE || error.data.status == statuscode.FAILURE) {
	                    errorAlert();
	                } else if (error.data.status == statuscode.NOTFOUND_DATA_MAIN) {
	                	redirectToDataNotFoundPage();
	                } else if (error.data.status == statuscode.NOTFOUND_DATA_SUB) {
	                    console.log("数据丢失：",error);
	                }
	                //console.log(error);
	            }
	        }
    	}]
    }

    var $iq_httpInterceptor = function($q, $iq_config, $iq_httpError, $templateCache) {
        return {
            "request": function(config) {
                if (config.url) {
                    if ($templateCache.get(config.url)) {
                        return config;
                    } else if (config.url.slice(-5) == ".html") {
                        config.url = config.url + "?v=" + $iq_config.config().version;
                    }
                }
                return config
            },
            "response": function(response) {
                return response;
            },
            'responseError': function(rejection) {

                $iq_httpError.dealError(rejection);

                return $q.reject(rejection);
            }
        }
    }


    var $iq_cities = function($iq_http, $q) {
        var cityconfig = null;
        var getCityConfig = function() {
            var url = "../data/city.json";
            var def = $q.defer();
            if (cityconfig == null) {
                $iq_http.http({
                    url: url,
                    type: "JSON",
                    method: "GET"
                }).then(function(re) {
                    cityconfig = re.data;
                    def.resolve(re.data);
                }, function(e) {
                    console.log(e);
                })
            } else {
                def.resolve(cityconfig);
            }
            return def.promise;
        }
        return {
            getCityConfig: getCityConfig,
            returnCityConfig: function() {
                return cityConfig;
            }
        }
    }
    var $iq_server = function($location, $iq_config) {
        var host = $location.protocol() + "://" + $location.host() + ":" + $location.port() + "";
        return {
            server: function() {
                if ($iq_config.server_path()) {
                    return $iq_config.server_path();
                }
                return host + "/iquicker_web/";
            },
            kkserver: function() {
                if ($iq_config.server_path()) {
                    return $iq_config.server_path();
                }
                return host + "/kkfile-server/";
            },
            management_server: function() {
                if ($iq_config.server_path()) {
                    return $iq_config.server_path();
                }
                return host + "/iquicker_management/";
            },
            client: function() {
                if ($iq_config.client_path()) {
                    return $iq_config.client_path();
                }
                var tmp = (location.pathname).replace(/\/+/g, "/").replace("/login", "");
                return host + tmp;
            }
        }
    }
    var $iq_http = function($http, $q, $iq_httpError) {

        var http = function(p_param, funcs) { //如果funcs为空则直接返回promise
            var param = angular.copy(p_param)
                /*
                 * param:{ method :"GET"/"POST", url :"someUrl", params
                 * :{key1:value1,key2:value2}, data :{string|Object}, timeout
                 * :{number|Promise} }
                 */
            if (param.headers) {
                param.headers["X-Requested-With"] = "XMLHttpRequest";
            } else {
                param.headers = {
                    "X-Requested-With": "XMLHttpRequest",
                };
            }
            if (param.method.toLowerCase() == "get") {
                if (param.params == undefined) {
                    param.params = {
                        m: new Date().getTime()
                    };

                } else if (param.params.m == undefined) {
                    param.params.m = new Date().getTime();
                } else {
                    param.params["m" + (new Date().getTime())] = new Date().getTime();
                }
            }
            if (funcs) { //回调方式
                return $http(param).then(function(obj) {
                    // success
                    if (obj.data && obj.data.status) {
                        var status = obj.data.status + "";
                        if (!status.match(/^2\w+/)) { //放开 以2开头的所有

                            $iq_httpError.dealError(obj); //通用错误处理

                            if (funcs.error) {
                                funcs.error(obj);
                            }
                            return;
                        }
                    }
                    if (funcs.success) {
                        funcs.success(obj);
                    }
                }, function(obj) {
                    //console.log(param);
                    // error
                    if (funcs.error) {
                        funcs.error(obj);
                    }
                });
            } else { //promise方式
                //              return $http(param);
                var def = $q.defer();
                $http(param).then(function(obj) {

                    if (obj.data && obj.data.status) {
                        var status = obj.data.status + "";
                        if (!status.match(/^2\w+/)) { //放开 以2开头的所有

                            $iq_httpError.dealError(obj);

                            def.reject(obj);
                            return def.promise;
                        } else {
                            $iq_httpError.logined();
                        }
                    }
                    def.resolve(obj);
                }, function(error) {
                    console.log(param);
                    def.reject(error);
                })
                return def.promise;
            }
        }
        return {
            http: http
        }
    }

    var $iq_window = function($iqmodal, $templateCache, $timeout) {

        return {
            alert: function(_option) {
            	var options = {};
            	//type :success fail warn
                if (angular.isString(_option)) {
                	options = {
                        message: _option,
                        timeout: 3,
                        type: "success"
                    };
                }else {
            		options = angular.extend({
                        message: "",
                        timeout: 3,
                        type: "success"
	                },_option);
                }

                var modalInstance = $iqmodal.open({
                    windowClass: 'modal mymodal alert-modal fail-modal success-modal',
                    template: $templateCache.get("templates/iq_common/alert.htm"),
                    resolve: {
                        options: function() {
                            return options;
                        }
                    },
                    controller: function($scope, $modalInstance, $timeout, options) {
                        $scope.options = options

                        if(options.timeout && angular.isNumber(options.timeout)){
                            $timeout(function() {
                                $modalInstance.close('ok')
                            }, options.timeout*1000)
                        }

                        $scope.ok = function() {
                            $modalInstance.close('ok');
                        };
                    }
                });
                modalInstance.opened.then(function(){
                	$timeout(function(){
                    	$(".modal.mymodal").on("click mouseup mousedown",function($event){
                    		$event.stopPropagation();
                    	})
                	})
                })
                return modalInstance.result;
            },
            confirm: function(_option) {
            	var options ={}
            	if(angular.isString(_option)){
            		options = {
                        message: _option,
                        okButtonText: '确定',
                        cancelButtonText: '取消'
                    };
            	}
            	else{
            		options = angular.extend({
	                    message: "",
	                    okButtonText: '确定',
	                    cancelButtonText: '取消'
	                },_option);
            	}

                var modalInstance = $iqmodal.open({
                    backdrop: "static",
                    windowClass: 'mymodal confirm-modal modal',
                    template: $templateCache.get("templates/iq_common/confirm.htm"),
                    resolve: {
                        options: function() {
                            return options;
                        }
                    },
                    controller: function($scope, $modalInstance, options) {
                        $scope.options = angular.copy(options);
                        $scope.ok = function() {
                            $modalInstance.close('ok');
                        };
                        $scope.cancel = function() {
                            $modalInstance.dismiss('cancel');
                        };
                    }
                });
                modalInstance.opened.then(function(){
                	$timeout(function(){
                    	$(".modal.mymodal").on("click mouseup mousedown",function($event){
                    		$event.stopPropagation();
                    	})
                	})
                })
                return modalInstance.result;
            },

            select: function(obj){
    			var _opt = angular.extend(obj,{
    				label:'选择弹出框...',
					okName:"保存",
					cancelName:"取消",
					multiple:false
    			})
    			return null;
            }
        }
    }
    angular.module('iq_common')
        .provider("$iq_config", $iq_config)
        .provider('$iq_loading', $iq_loading)
        .provider('$iq_queue', $iq_queue)
        .provider('$iq_httpError', $iq_httpError)
        .factory('$iq_httpInterceptor', ["$q", "$iq_config", "$iq_httpError", "$templateCache", $iq_httpInterceptor])
        .service("$iq_http", ["$http", "$q", "$iq_httpError", $iq_http])
        .service("$iq_cities", ["$iq_http", "$q", $iq_cities])
        .service("$iq_server", ["$location", "$iq_config", $iq_server])
        .service("$iq_window", ["$iqmodal", "$templateCache", "$timeout", $iq_window])
        .run(["$templateCache", function($templateCache) {
            $templateCache.put("templates/iq_common/alert.htm", '<div class="modal-header"><button type="button" class="close" ng-click="ok()"><span aria-hidden="true">×</span></button></div><div class="modal-body" ng-if="options.type == \'success\'"><span class="status-success"><i class="iqon-right"></i></span><span class="success-tips" ng-bind="options.message"></span></div><div class="modal-body" ng-if="options.type == \'fail\'"><span class="status-fail"><i class="iqon-close"></i></span><span class="fail-tips" ng-bind="options.message"></span></div><div class="modal-body" ng-if="options.type == \'warn\'"><div class="alert-tips" ng-bind="options.message"></div></div>');
            $templateCache.put("templates/iq_common/confirm.htm", '<div class="modal-body"><div class="confirm-tips" ng-bind="options.message"> </div><div class="btn-groups"><input type="button" ng-value="options.okButtonText" class="btn btn-medium btn-save" ng-click="ok()"></input><input type="button" ng-value="options.cancelButtonText" class="btn btn-medium btn-light btn-cancel" ng-click="cancel()"></input></div></div>');
        }])
})();
